<template>
	<div class="user-form-container">
		<!-- 页面头部 -->
		<div class="page-header">
			<div class="header-content">
				<div class="header-left">
					<div class="back-button" @click="back()">
						<i class="el-icon-arrow-left"></i>
					</div>
					<div class="header-info">
						<h1 class="page-title">
							{{ type === 'info' ? '用户详情' : (id ? '编辑用户' : '新增用户') }}
						</h1>
						<div class="breadcrumb">
							<span class="breadcrumb-item">用户管理</span>
							<i class="el-icon-arrow-right"></i>
							<span class="breadcrumb-current">
								{{ type === 'info' ? '查看详情' : (id ? '编辑用户' : '新增用户') }}
							</span>
						</div>
					</div>
				</div>
				<div class="header-actions" v-if="type !== 'info'">
					<el-button @click="back()" class="cancel-btn">
						<i class="el-icon-close"></i>
						取消
					</el-button>
					<el-button type="primary" @click="onSubmit" :loading="submitLoading" class="submit-btn">
						<i class="el-icon-check"></i>
						{{ submitLoading ? '保存中...' : '保存' }}
					</el-button>
				</div>
				<div class="header-actions" v-else>
					<el-button @click="back()" class="back-btn">
						<i class="el-icon-back"></i>
						返回
					</el-button>
				</div>
			</div>
		</div>

		<!-- 表单内容 -->
		<div class="form-content">
			<el-form
				ref="ruleForm"
				:model="ruleForm"
				:rules="rules"
				label-width="120px"
				class="user-form"
			>
				<!-- 基本信息 -->
				<div class="form-section">
					<h3 class="section-title">基本信息</h3>
					
					<!-- 用户账号 -->
					<el-form-item label="用户账号" prop="yonghuzhanghao" class="form-item">
						<div class="input-wrapper">
							<div class="input-field" :class="{ 'readonly': type === 'info' || ro.yonghuzhanghao }">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.yonghuzhanghao" 
									placeholder="请输入用户账号" 
									:readonly="type === 'info' || ro.yonghuzhanghao"
									clearable
									class="form-input"
								></el-input>
								<div class="readonly-indicator" v-if="type === 'info' || ro.yonghuzhanghao">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
							<span class="field-tip" v-if="type !== 'info'">账号长度为3-10个字符</span>
						</div>
					</el-form-item>

					<!-- 密码 -->
					<el-form-item label="密码" prop="mima" class="form-item">
						<div class="input-wrapper">
							<div class="input-field" :class="{ 'readonly': type === 'info' || ro.mima }">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.mima" 
									:type="showPassword ? 'text' : 'password'"
									placeholder="请输入密码" 
									:readonly="type === 'info' || ro.mima"
									clearable
									class="form-input"
								></el-input>
								<div class="field-actions" v-if="type !== 'info' && !ro.mima">
									<button type="button" class="toggle-btn" @click="showPassword = !showPassword">
										<svg v-if="!showPassword" class="toggle-icon" viewBox="0 0 24 24">
											<path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"/>
										</svg>
										<svg v-else class="toggle-icon" viewBox="0 0 24 24">
											<path d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.09L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.76,7.13 11.37,7 12,7Z"/>
										</svg>
									</button>
								</div>
								<div class="readonly-indicator" v-if="type === 'info' || ro.mima">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
							<span class="field-tip" v-if="type !== 'info'">密码长度为3-10个字符</span>
						</div>
					</el-form-item>

					<!-- 用户姓名 -->
					<el-form-item label="用户姓名" prop="yonghuxingming" class="form-item">
						<div class="input-wrapper">
							<div class="input-field" :class="{ 'readonly': type === 'info' || ro.yonghuxingming }">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.yonghuxingming" 
									placeholder="请输入用户姓名" 
									:readonly="type === 'info' || ro.yonghuxingming"
									clearable
									class="form-input"
								></el-input>
								<div class="readonly-indicator" v-if="type === 'info' || ro.yonghuxingming">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
						</div>
					</el-form-item>

					<!-- 性别 -->
					<el-form-item label="性别" prop="xingbie" class="form-item">
						<div class="input-wrapper">
							<div class="gender-selector" v-if="type !== 'info' && !ro.xingbie">
								<div 
									v-for="(option, index) in xingbieOptions" 
									:key="index"
									class="gender-option"
									:class="{ 'active': ruleForm.xingbie === option }"
									@click="selectGender(option)"
								>
									<div class="gender-icon">
										<svg v-if="option === '男'" viewBox="0 0 24 24">
											<path d="M9,9C10.29,8.99 11.4,9.73 11.83,10.86C12.25,12 11.93,13.28 11,14C9.89,14.96 8.11,14.73 7.29,13.56C6.46,12.38 6.84,10.7 8.17,10.04C8.43,9.86 8.72,9.92 9,9M12,3.5L18,9.5H15V16.5H9V13.5H6L12,3.5Z"/>
										</svg>
										<svg v-else viewBox="0 0 24 24">
											<path d="M12,2A3,3 0 0,1 15,5A3,3 0 0,1 12,8A3,3 0 0,1 9,5A3,3 0 0,1 12,2M21,9V11H19V9L17,11V20A2,2 0 0,1 15,22H9A2,2 0 0,1 7,20V11L5,9V11H3V9L6,6H18L21,9Z"/>
										</svg>
									</div>
									<span class="gender-text">{{ option }}</span>
								</div>
							</div>
							<div v-else class="readonly-display">
								<div class="readonly-gender">
									<i :class="getGenderIcon(ruleForm.xingbie)"></i>
									<span>{{ ruleForm.xingbie || '未设置' }}</span>
								</div>
							</div>
						</div>
					</el-form-item>

					<!-- 联系方式 -->
					<el-form-item label="联系方式" prop="lianxifangshi" class="form-item">
						<div class="input-wrapper">
							<div class="input-field" :class="{ 'readonly': type === 'info' || ro.lianxifangshi }">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.lianxifangshi" 
									placeholder="请输入手机号码" 
									:readonly="type === 'info' || ro.lianxifangshi"
									clearable
									class="form-input"
									:class="{ 'error': contactError }"
									@blur="validateContact"
								></el-input>
								<div class="field-status">
									<svg v-if="contactValid" class="status-icon success" viewBox="0 0 24 24">
										<path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"/>
									</svg>
									<svg v-if="contactError" class="status-icon error" viewBox="0 0 24 24">
										<path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
									</svg>
								</div>
								<div class="readonly-indicator" v-if="type === 'info' || ro.lianxifangshi">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
							<div v-if="contactError" class="error-tip">请输入正确的手机号码格式</div>
						</div>
					</el-form-item>
				</div>

				<!-- 头像设置 -->
				<div class="form-section">
					<h3 class="section-title">头像设置</h3>
					
					<el-form-item label="个人头像" prop="touxiang" class="form-item avatar-item">
						<div class="avatar-upload-wrapper">
							<div class="current-avatar">
								<!-- 显示已有头像 -->
								<div v-if="ruleForm.touxiang" class="avatar-preview">
									<img 
										v-if="ruleForm.touxiang.substring(0,4)==='http'" 
										:src="ruleForm.touxiang.split(',')[0]" 
										class="preview-image"
									>
									<img 
										v-else 
										:src="$base.url + ruleForm.touxiang.split(',')[0]" 
										class="preview-image"
									>
								</div>
								<!-- 无头像占位 -->
								<div v-else class="avatar-placeholder-large">
									<svg class="placeholder-icon-large" viewBox="0 0 24 24">
										<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
									</svg>
									<p class="placeholder-text">暂无头像</p>
								</div>
							</div>
							
							<!-- 上传控件 -->
							<div class="upload-controls" v-if="type !== 'info' && !ro.touxiang">
								<file-upload
									tip="点击上传头像"
									action="file/upload"
									:limit="1"
									:multiple="false"
									:fileUrls="ruleForm.touxiang ? ruleForm.touxiang : ''"
									@change="touxiangUploadChange"
									class="custom-upload"
								></file-upload>
								<div class="upload-tips">
									<p class="tip-text">• 支持 JPG、PNG 格式</p>
									<p class="tip-text">• 建议尺寸 200x200 像素</p>
									<p class="tip-text">• 文件大小不超过 2MB</p>
								</div>
							</div>
						</div>
					</el-form-item>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isPhone, isMobile,isURL,checkIdCard } from "@/utils/validate";
export default {
	data() {
		let self = this
		var validateIdCard = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!checkIdCard(value)) {
				callback(new Error("请输入正确的身份证号码"));
			} else {
				callback();
			}
		};
		var validateUrl = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isURL(value)) {
				callback(new Error("请输入正确的URL地址"));
			} else {
				callback();
			}
		};
		var validateMobile = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isMobile(value)) {
				callback(new Error("请输入正确的手机号码"));
			} else {
				callback();
			}
		};
		var validatePhone = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isPhone(value)) {
				callback(new Error("请输入正确的电话号码"));
			} else {
				callback();
			}
		};
		var validateEmail = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isEmail(value)) {
				callback(new Error("请输入正确的邮箱地址"));
			} else {
				callback();
			}
		};
		var validateNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isNumber(value)) {
				callback(new Error("请输入数字"));
			} else {
				callback();
			}
		};
		var validateIntNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isIntNumer(value)) {
				callback(new Error("请输入整数"));
			} else {
				callback();
			}
		};
		return {
			id: '',
			type: '',
			showPassword: false, // 密码显示控制
			submitLoading: false, // 提交加载状态
			contactError: false, // 联系方式错误状态
			contactValid: false, // 联系方式正确状态
			
			ro:{
				yonghuzhanghao : false,
				mima : false,
				yonghuxingming : false,
				touxiang : false,
				xingbie : false,
				lianxifangshi : false,
				money : false,
			},
			
			ruleForm: {
				yonghuzhanghao: '',
				mima: '',
				yonghuxingming: '',
				touxiang: '',
				xingbie: '',
				lianxifangshi: '',
			},
		
			xingbieOptions: [],
			
			rules: {
				yonghuzhanghao: [
				],
				mima: [
					{ required: true, message: '密码不能为空', trigger: 'blur' },
				],
				yonghuxingming: [
				],
				touxiang: [
				],
				xingbie: [
				],
				lianxifangshi: [
					{ validator: validateMobile, trigger: 'blur' },
				],
				money: [
					{ validator: validateNumber, trigger: 'blur' },
				],
			}
		};
	},
	props: ["parent"],
	computed: {},
	created() {
	},
	methods: {
		
		// 选择性别
		selectGender(gender) {
			this.ruleForm.xingbie = gender;
		},

		// 验证联系方式
		validateContact() {
			if (this.ruleForm.lianxifangshi) {
				this.contactError = !isMobile(this.ruleForm.lianxifangshi);
				this.contactValid = isMobile(this.ruleForm.lianxifangshi);
			} else {
				this.contactError = false;
				this.contactValid = false;
			}
		},

		// 获取性别图标
		getGenderIcon(gender) {
			if (gender === '男') return 'el-icon-male';
			if (gender === '女') return 'el-icon-female';
			return 'el-icon-question';
		},
		
		// 下载
		download(file){
			window.open(`${file}`)
		},
		// 初始化
		init(id,type) {
			if (id) {
				this.id = id;
				this.type = type;
			}
			if(this.type=='info'||this.type=='else'){
				this.info(id);
			}else if(this.type=='logistics'){
				this.logistics=false;
				this.info(id);
			}else if(this.type=='cross'){
				var obj = this.$storage.getObj('crossObj');
				for (var o in obj){
						if(o=='yonghuzhanghao'){
							this.ruleForm.yonghuzhanghao = obj[o];
							this.ro.yonghuzhanghao = true;
							continue;
						}
						if(o=='mima'){
							this.ruleForm.mima = obj[o];
							this.ro.mima = true;
							continue;
						}
						if(o=='yonghuxingming'){
							this.ruleForm.yonghuxingming = obj[o];
							this.ro.yonghuxingming = true;
							continue;
						}
						if(o=='touxiang'){
							this.ruleForm.touxiang = obj[o];
							this.ro.touxiang = true;
							continue;
						}
						if(o=='xingbie'){
							this.ruleForm.xingbie = obj[o];
							this.ro.xingbie = true;
							continue;
						}
						if(o=='lianxifangshi'){
							this.ruleForm.lianxifangshi = obj[o];
							this.ro.lianxifangshi = true;
							continue;
						}
						if(o=='money'){
							this.ruleForm.money = obj[o];
							this.ro.money = true;
							continue;
						}
				}
			}
			
			// 获取用户信息
			this.$http({
				url: `${this.$storage.get('sessionTable')}/session`,
				method: "get"
			}).then(({ data }) => {
				if (data && data.code === 0) {
					var json = data.data;
				} else {
					this.$message.error(data.msg);
				}
			});
			
            this.xingbieOptions = "男,女".split(',')
		},

		info(id) {
			this.$http({
				url: `yonghu/info/${id}`,
				method: "get"
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.ruleForm = data.data;
					//解决前台上传图片后台不显示的问题
					let reg=new RegExp('../../../upload','g')//g代表全部
				} else {
					this.$message.error(data.msg);
				}
			});
		},

		// 提交
		onSubmit() {
			if((this.ruleForm.yonghuzhanghao.length<3)){
				this.$message.error(`用户账号长度不能小于3`);
				return
			}
			if((this.ruleForm.yonghuzhanghao.length>10)){
				this.$message.error(`用户账号长度不能大于10`);
				return
			}

			if((this.ruleForm.mima.length<3)){
				this.$message.error(`密码长度不能小于3`);
				return
			}
			if((this.ruleForm.mima.length>10)){
				this.$message.error(`密码长度不能大于10`);
				return
			}

			if(this.ruleForm.touxiang!=null) {
				this.ruleForm.touxiang = this.ruleForm.touxiang.replace(new RegExp(this.$base.url,"g"),"");
			}

			var objcross = this.$storage.getObj('crossObj');

			//更新跨表属性
			var crossuserid;
			var crossrefid;
			var crossoptnum;
			if(this.type=='cross'){
				var statusColumnName = this.$storage.get('statusColumnName');
				var statusColumnValue = this.$storage.get('statusColumnValue');
				if(statusColumnName!='') {
					var obj = this.$storage.getObj('crossObj');
					if(statusColumnName && !statusColumnName.startsWith("[")) {
						for (var o in obj){
							if(o==statusColumnName){
								obj[o] = statusColumnValue;
							}
						}
						var table = this.$storage.get('crossTable');
						this.$http({
							url: `${table}/update`,
							method: "post",
							data: obj
						}).then(({ data }) => {});
					} else {
						crossuserid=this.$storage.get('userid');
						crossrefid=obj['id'];
						crossoptnum=this.$storage.get('statusColumnName');
						crossoptnum=crossoptnum.replace(/\[/,"").replace(/\]/,"");
					}
				}
			}

			this.submitLoading = true;

			this.$refs["ruleForm"].validate(valid => {
				if (valid) {
					if(crossrefid && crossuserid) {
						this.ruleForm.crossuserid = crossuserid;
						this.ruleForm.crossrefid = crossrefid;
						let params = { 
							page: 1, 
							limit: 10, 
							crossuserid:this.ruleForm.crossuserid,
							crossrefid:this.ruleForm.crossrefid,
						} 
						this.$http({ 
							url: "yonghu/page", 
							method: "get", 
							params: params 
						}).then(({ 
							data 
						}) => { 
							if (data && data.code === 0) { 
								if(data.data.total>=crossoptnum) {
									this.$message.error(this.$storage.get('tips'));
									this.submitLoading = false;
									return false;
								} else {
									this.$http({
										url: `yonghu/${!this.ruleForm.id ? "save" : "update"}`,
										method: "post",
										data: this.ruleForm
									}).then(({ data }) => {
										this.submitLoading = false;
										if (data && data.code === 0) {
											this.$message({
												message: "操作成功",
												type: "success",
												duration: 1500,
												onClose: () => {
													this.parent.showFlag = true;
													this.parent.addOrUpdateFlag = false;
													this.parent.yonghuCrossAddOrUpdateFlag = false;
													this.parent.search();
													this.parent.contentStyleChange();
												}
											});
										} else {
											this.$message.error(data.msg);
										}
									});
								}
							} else { 
								this.submitLoading = false;
							} 
						});
					} else {
						this.$http({
							url: `yonghu/${!this.ruleForm.id ? "save" : "update"}`,
							method: "post",
							data: this.ruleForm
						}).then(({ data }) => {
							this.submitLoading = false;
							if (data && data.code === 0) {
								this.$message({
									message: "操作成功",
									type: "success",
									duration: 1500,
									onClose: () => {
										this.parent.showFlag = true;
										this.parent.addOrUpdateFlag = false;
										this.parent.yonghuCrossAddOrUpdateFlag = false;
										this.parent.search();
										this.parent.contentStyleChange();
									}
								});
							} else {
								this.$message.error(data.msg);
							}
						});
					}
				} else {
					this.submitLoading = false;
				}
			});
		},
		// 获取uuid
		getUUID () {
			return new Date().getTime();
		},
		// 返回
		back() {
			this.parent.showFlag = true;
			this.parent.addOrUpdateFlag = false;
			this.parent.yonghuCrossAddOrUpdateFlag = false;
			this.parent.contentStyleChange();
		},
		touxiangUploadChange(fileUrls) {
			this.ruleForm.touxiang = fileUrls;
		},
	}
};
</script>
<style lang="scss" scoped>
.user-form-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-left {
			display: flex;
			align-items: center;
			gap: 16px;

			.back-button {
				width: 40px;
				height: 40px;
				border-radius: 8px;
				background: #f3f4f6;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				transition: all 0.2s ease;

				&:hover {
					background: #e5e7eb;
					color: #3b82f6;
				}

				i {
					font-size: 16px;
				}
			}

			.header-info {
				.page-title {
					font-size: 24px;
					font-weight: 600;
					color: #1e293b;
					margin: 0 0 4px 0;
				}

				.breadcrumb {
					display: flex;
					align-items: center;
					gap: 8px;
					color: #64748b;
					font-size: 14px;

					.breadcrumb-item {
						color: #9ca3af;
					}

					.breadcrumb-current {
						color: #3b82f6;
						font-weight: 500;
					}

					i {
						font-size: 12px;
						color: #cbd5e1;
					}
				}
			}
		}

		.header-actions {
			display: flex;
			gap: 12px;

			.el-button {
				padding: 10px 20px;
				font-weight: 500;
				border-radius: 8px;

				i {
					margin-right: 4px;
				}
			}

			.cancel-btn {
				color: #6b7280;
				border-color: #d1d5db;

				&:hover {
					color: #374151;
					border-color: #9ca3af;
				}
			}

			.submit-btn {
				background: #3b82f6;
				border-color: #3b82f6;

				&:hover {
					background: #2563eb;
					border-color: #2563eb;
				}
			}

			.back-btn {
				color: #6b7280;
				border-color: #d1d5db;

				&:hover {
					color: #374151;
					border-color: #9ca3af;
				}
			}
		}
	}
}

// 表单内容
.form-content {
	max-width: 800px;
	margin: 0 auto;
}

// 用户表单
.user-form {
	background: white;
	padding: 32px;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

	.form-section {
		margin-bottom: 32px;

		&:last-of-type {
			margin-bottom: 0;
		}

		.section-title {
			font-size: 18px;
			font-weight: 600;
			color: #1e293b;
			margin: 0 0 24px 0;
			padding-bottom: 8px;
			border-bottom: 2px solid #e2e8f0;
		}
	}

	// 表单项
	.form-item {
		margin-bottom: 24px;

		:deep(.el-form-item__label) {
			font-weight: 500;
			color: #374151;
			line-height: 32px;
		}

		&.avatar-item {
			:deep(.el-form-item__content) {
				line-height: 1;
			}
		}
	}

	// 输入包装器
	.input-wrapper {
		width: 100%;
	}

	// 输入字段
	.input-field {
		position: relative;
		display: flex;
		align-items: center;
		border: 1px solid #d1d5db;
		border-radius: 8px;
		transition: all 0.2s ease;
		background: #fafafa;

		&:focus-within {
			border-color: #3b82f6;
			box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
			background: white;
		}

		&.readonly {
			background: #f9fafb;
			border-color: #e5e7eb;

			&:focus-within {
				border-color: #e5e7eb;
				box-shadow: none;
			}
		}

		.field-icon {
			width: 18px;
			height: 18px;
			fill: #9ca3af;
			margin: 0 12px 0 16px;
			flex-shrink: 0;
		}

		.form-input {
			flex: 1;

			:deep(.el-input__inner) {
				border: none;
				background: transparent;
				font-size: 14px;
				padding: 12px 16px 12px 0;
				height: auto;

				&:focus {
					border: none;
					box-shadow: none;
				}

				&::placeholder {
					color: #9ca3af;
				}

				&[readonly] {
					color: #6b7280;
					cursor: default;
				}
			}
		}

		// 字段操作（密码切换）
		.field-actions {
			margin-right: 12px;

			.toggle-btn {
				border: none;
				background: none;
				cursor: pointer;
				color: #9ca3af;
				transition: color 0.2s ease;

				&:hover {
					color: #3b82f6;
				}

				.toggle-icon {
					width: 16px;
					height: 16px;
					fill: currentColor;
				}
			}
		}

		// 字段状态
		.field-status {
			margin-right: 12px;

			.status-icon {
				width: 16px;
				height: 16px;

				&.success {
					fill: #10b981;
				}

				&.error {
					fill: #ef4444;
				}
			}
		}

		// 只读指示器
		.readonly-indicator {
			margin-right: 12px;

			.lock-icon {
				width: 14px;
				height: 14px;
				fill: #9ca3af;
			}
		}
	}

	// 字段提示
	.field-tip {
		color: #6b7280;
		font-size: 12px;
		margin-top: 4px;
	}

	// 错误提示
	.error-tip {
		color: #ef4444;
		font-size: 12px;
		margin-top: 4px;
		display: flex;
		align-items: center;
		gap: 4px;
	}
}

// 性别选择器
.gender-selector {
	display: flex;
	gap: 12px;

	.gender-option {
		flex: 1;
		padding: 12px 16px;
		border: 2px solid #e5e7eb;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s ease;
		display: flex;
		align-items: center;
		gap: 8px;
		background: white;

		&:hover {
			border-color: #cbd5e1;
			background: #f8fafc;
		}

		&.active {
			border-color: #3b82f6;
			background: #eff6ff;
			color: #1d4ed8;

			.gender-icon svg {
				fill: #1d4ed8;
			}
		}

		.gender-icon {
			width: 20px;
			height: 20px;
			display: flex;
			align-items: center;
			justify-content: center;

			svg {
				width: 16px;
				height: 16px;
				fill: #6b7280;
				transition: fill 0.2s ease;
			}
		}

		.gender-text {
			font-size: 14px;
			font-weight: 500;
		}
	}
}

// 只读显示
.readonly-display {
	.readonly-gender {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 12px 16px;
		background: #f9fafb;
		border-radius: 6px;
		color: #374151;

		i {
			font-size: 16px;
			color: #6b7280;
		}
	}
}

// 头像上传
.avatar-upload-wrapper {
	display: flex;
	gap: 24px;
	align-items: flex-start;

	.current-avatar {
		.avatar-preview {
			width: 120px;
			height: 120px;
			border-radius: 8px;
			overflow: hidden;
			border: 2px solid #e5e7eb;

			.preview-image {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.avatar-placeholder-large {
			width: 120px;
			height: 120px;
			border-radius: 8px;
			border: 2px dashed #cbd5e1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background: #f9fafb;

			.placeholder-icon-large {
				width: 32px;
				height: 32px;
				fill: #9ca3af;
				margin-bottom: 8px;
			}

			.placeholder-text {
				color: #6b7280;
				font-size: 12px;
				margin: 0;
			}
		}
	}

	.upload-controls {
		flex: 1;

		.custom-upload {
			margin-bottom: 16px;
		}

		.upload-tips {
			.tip-text {
				color: #6b7280;
				font-size: 12px;
				margin: 0 0 4px 0;
				line-height: 1.4;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}

// 文件上传组件样式覆盖
:deep(.custom-upload) {
	.el-upload {
		border: 2px dashed #cbd5e1;
		border-radius: 8px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		transition: all 0.2s ease;
		background: white;
		padding: 16px;
		text-align: center;
		min-height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;

		&:hover {
			border-color: #3b82f6;
			background: #f8fafc;
		}
	}

	.el-upload-dragger {
		background: transparent;
		border: none;
		width: 100%;
		height: auto;
		min-height: auto;
		border-radius: 0;
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.user-form-container {
		padding: 20px;
	}

	.form-content {
		max-width: 100%;
	}

	.avatar-upload-wrapper {
		flex-direction: column;
		gap: 16px;
		align-items: center;
	}
}

@media (max-width: 768px) {
	.user-form-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;

			.header-left {
				width: 100%;
				justify-content: flex-start;
			}

			.header-actions {
				width: 100%;
				justify-content: center;

				.el-button {
					flex: 1;
					max-width: 120px;
				}
			}
		}
	}

	.user-form {
		padding: 24px;

		.form-section {
			margin-bottom: 24px;

			.section-title {
				font-size: 16px;
			}
		}

		.form-item {
			margin-bottom: 20px;

			:deep(.el-form-item__label) {
				font-size: 14px;
			}
		}
	}

	.gender-selector {
		flex-direction: column;
		gap: 8px;

		.gender-option {
			justify-content: center;
		}
	}
}

@media (max-width: 480px) {
	.user-form-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-left {
				.back-button {
					width: 36px;
					height: 36px;
				}

				.header-info {
					.page-title {
						font-size: 18px;
					}

					.breadcrumb {
						font-size: 12px;
					}
				}
			}

			.header-actions {
				.el-button {
					padding: 8px 12px;
					font-size: 13px;
				}
			}
		}
	}

	.user-form {
		padding: 20px;

		.input-field {
			.field-icon {
				margin: 0 8px 0 12px;
			}

			.form-input {
				:deep(.el-input__inner) {
					font-size: 16px; // 防止移动端缩放
				}
			}
		}
	}

	.avatar-upload-wrapper {
		.current-avatar {
			.avatar-preview,
			.avatar-placeholder-large {
				width: 100px;
				height: 100px;
			}
		}
	}
}
</style>
